var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "reward-extract-tab" },
    [
      _c(
        "b-row",
        { staticClass: "mb-0" },
        [
          _c(
            "b-col",
            { attrs: { cols: "12" } },
            [
              _c(
                "b-card",
                { staticClass: "mb-0" },
                [
                  _c(
                    "b-card-text",
                    [
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { attrs: { cols: "6", md: "3" } },
                            [
                              _c("statistic-card-horizontal", {
                                attrs: {
                                  icon: "DollarSignIcon",
                                  statistic: _vm._f("currency")(
                                    _vm.rewardSummary.currentBalance
                                  ),
                                  "statistic-title": "Saldo Atual",
                                  color: "success",
                                  "custom-style": {
                                    border: "1px solid #28c76f33",
                                    borderRadius: "8px",
                                    backgroundColor: "#e6fffa33",
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { attrs: { cols: "6", md: "3" } },
                            [
                              _c("statistic-card-horizontal", {
                                attrs: {
                                  icon: "AwardIcon",
                                  statistic: _vm._f("currency")(
                                    _vm.rewardSummary.totalEarned
                                  ),
                                  "statistic-title": "Total Ganho",
                                  color: "success",
                                  "custom-style": {
                                    border: "1px solid #28c76f33",
                                    borderRadius: "8px",
                                    backgroundColor: "#e6fffa33",
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { attrs: { cols: "6", md: "3" } },
                            [
                              _c("statistic-card-horizontal", {
                                attrs: {
                                  icon: "SmileIcon",
                                  statistic: _vm._f("currency")(
                                    _vm.rewardSummary.totalUsed
                                  ),
                                  "statistic-title": "Total Utilizado",
                                  color: "warning",
                                  "custom-style": {
                                    border: "1px solid rgb(255 243 232)",
                                    borderRadius: "8px",
                                    backgroundColor: "rgb(255 249 230)",
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { attrs: { cols: "6", md: "3" } },
                            [
                              _c("statistic-card-horizontal", {
                                attrs: {
                                  icon: "ClockIcon",
                                  statistic: _vm._f("currency")(
                                    _vm.rewardSummary.totalExpired
                                  ),
                                  "statistic-title": "Total Expirado",
                                  color: "danger",
                                  "custom-style": {
                                    border: "1px solid rgb(252 234 234)",
                                    borderRadius: "8px",
                                    backgroundColor: "rgb(255 244 246)",
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-row",
        { staticClass: "mb-3" },
        [
          _c(
            "b-col",
            { attrs: { cols: "12", md: "4" } },
            [
              _c("FormulateInput", {
                attrs: {
                  label: _vm.$t("Tipo de Transação"),
                  placeholder: _vm.$t("Todos"),
                  type: "vue-select",
                  options: _vm.transactionTypeOptions,
                },
                on: { input: _vm.onFilterChange },
                model: {
                  value: _vm.filters.transactionType,
                  callback: function ($$v) {
                    _vm.$set(_vm.filters, "transactionType", $$v)
                  },
                  expression: "filters.transactionType",
                },
              }),
            ],
            1
          ),
          _c(
            "b-col",
            { attrs: { cols: "12", md: "4" } },
            [
              _c("FormulateInput", {
                attrs: {
                  label: _vm.$t("Data Inicial"),
                  placeholder: _vm.$t("Todos"),
                  type: "datepicker",
                },
                on: { input: _vm.onFilterChange },
                model: {
                  value: _vm.filters.startDate,
                  callback: function ($$v) {
                    _vm.$set(_vm.filters, "startDate", $$v)
                  },
                  expression: "filters.startDate",
                },
              }),
            ],
            1
          ),
          _c(
            "b-col",
            { attrs: { cols: "12", md: "4" } },
            [
              _c("FormulateInput", {
                attrs: {
                  label: _vm.$t("Data Final"),
                  placeholder: _vm.$t("Todos"),
                  type: "datepicker",
                },
                on: { input: _vm.onFilterChange },
                model: {
                  value: _vm.filters.endDate,
                  callback: function ($$v) {
                    _vm.$set(_vm.filters, "endDate", $$v)
                  },
                  expression: "filters.endDate",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("b-table", {
        attrs: {
          items: _vm.transactions,
          fields: _vm.tableFields,
          busy: _vm.loading,
          "sort-by": _vm.sortBy,
          "sort-desc": _vm.sortDesc,
          responsive: "",
          striped: "",
          hover: "",
          "show-empty": "",
          "empty-text": "Nenhuma transação encontrada",
        },
        on: {
          "update:sortBy": function ($event) {
            _vm.sortBy = $event
          },
          "update:sort-by": function ($event) {
            _vm.sortBy = $event
          },
          "update:sortDesc": function ($event) {
            _vm.sortDesc = $event
          },
          "update:sort-desc": function ($event) {
            _vm.sortDesc = $event
          },
        },
        scopedSlots: _vm._u([
          {
            key: "table-busy",
            fn: function () {
              return [
                _c(
                  "div",
                  { staticClass: "text-center text-muted my-2" },
                  [
                    _c("b-spinner", { staticClass: "align-middle mr-2" }),
                    _c("strong", [_vm._v("Carregando transações...")]),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "cell(amount)",
            fn: function (data) {
              return [
                _c(
                  "span",
                  { class: _vm.getAmountClass(data.item.transactionType) },
                  [_vm._v(" " + _vm._s(_vm._f("currency")(data.value)) + " ")]
                ),
              ]
            },
          },
          {
            key: "cell(expirationDate)",
            fn: function (data) {
              return [
                data.value
                  ? _c(
                      "span",
                      [
                        _vm._v(" " + _vm._s(_vm._f("date")(data.value)) + " "),
                        data.item.isExpired
                          ? _c(
                              "b-badge",
                              {
                                staticClass: "ml-1",
                                attrs: { variant: "danger" },
                              },
                              [_vm._v(" Expirado ")]
                            )
                          : _vm.isExpiringSoon(data.value)
                          ? _c(
                              "b-badge",
                              {
                                staticClass: "ml-1",
                                attrs: { variant: "warning" },
                              },
                              [_vm._v(" Expira em breve ")]
                            )
                          : _vm._e(),
                      ],
                      1
                    )
                  : _c("span", [_vm._v("-")]),
              ]
            },
          },
        ]),
      }),
      _vm.paging.rowCount > 0
        ? _c(
            "b-row",
            [
              _c(
                "b-col",
                {
                  staticClass:
                    "d-flex justify-content-between align-items-center",
                  attrs: { cols: "12" },
                },
                [
                  _c("e-pagination-summary", {
                    attrs: {
                      "current-page": _vm.paging.currentPage,
                      "per-page": _vm.paging.pageSize,
                      total: _vm.paging.rowCount,
                      "total-on-page": _vm.paging.rowsInCurrentPage,
                    },
                  }),
                  _c("b-pagination", {
                    attrs: {
                      "total-rows": _vm.paging.rowCount,
                      "per-page": _vm.paging.pageSize,
                    },
                    on: { change: _vm.onPageChange },
                    model: {
                      value: _vm.paging.currentPage,
                      callback: function ($$v) {
                        _vm.$set(_vm.paging, "currentPage", $$v)
                      },
                      expression: "paging.currentPage",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }